module.exports = __webpack_public_path__ + "static/media/sign-up-button.46af6933.png";